import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import { categoriesMap } from '../constants';
// tslint:disable-next-line no-var-requires
const countryCodesAlpha2 = require('../services/country-codes-alpha2.json');

export interface IAvailabilityLog {
  _id: ObjectID;
  service: ObjectID;
  category: string;
  city?: string;
  state?: string;
  countryCode?: string;
  startDate: Date;
  endDate: Date;
  adultCount: number;
  childrenCount: number;
  infantCount: number;
  available: boolean;
  minPrice: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface IAvailabilityLogDocument extends mongoose.Document, IAvailabilityLog {
  _id: ObjectID;
}

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;
export type IAvailabilityLogCreateData = Omit<IAvailabilityLog, '_id' | 'createdAt' | 'updatedAt'>;

const allowedCategories = Object.values(categoriesMap);
const schema = new Schema(
  {
    service: {
      type: Schema.Types.ObjectId,
      ref: 'Service',
      required: true,
    },
    category: {
      type: String,
      required: true,
      enum: allowedCategories,
    },
    city: {
      type: String,
    },
    state: {
      type: String,
    },
    countryCode: {
      type: String,
      enum: countryCodesAlpha2,
    },
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
    adultCount: {
      type: Number,
      required: true,
    },
    childrenCount: {
      type: Number,
      required: true,
    },
    infantCount: {
      type: Number,
      required: true,
      default: 0,
    },
    available: {
      type: Boolean,
      required: true,
    },
    minPrice: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  { timestamps: true },
);

schema.index({
  service: 1,
  adultCount: 1,
  childrenCount: 1,
  infantCount: 1,
  available: 1,
  _id: -1,
});

schema.index(
  {
    service: 1,
    adultCount: 1,
    childrenCount: 1,
    infantCount: 1,
    startDate: 1,
    endDate: 1,
    createdAt: -1,
    available: 1,
  },
  { name: 'service_adults_childs_infants_startDate_endDate_createdAt_available' },
);

const threeHoursInSeconds = 10_800;
schema.index({ createdAt: 1 }, { expireAfterSeconds: threeHoursInSeconds });

export default schema;
